import {inject, injectable} from 'inversify';

import type {BaseDomainFactory} from '../Base/BaseDomain.factory';

import {ModelsRegistry} from '../../system/modelsRegistry/ModelsRegistry';
import {TaskModel} from './Task.model';

@injectable()
export class TaskFactory
  implements BaseDomainFactory<TaskModel, TaskModel.Props>
{
  constructor(
    @inject(ModelsRegistry)
    private readonly modelsRegistry: ModelsRegistry,
  ) {}

  create(props: TaskModel.Props): TaskModel {
    return this.modelsRegistry.put(new TaskModel(props));
  }
}
